import './VastContent.scss';

import React from 'react';

import { AssetSlider } from '../../../../_ForCommonLibrary/components/organisms/AssetSlider';
import type { Asset2ReviewStatus, Asset2TranscodingStatus, IngestionTrial, Maybe } from '../../../../../apis/graphql';
import { CreativeV5Type } from '../../../../../apis/graphql';
import type { Asset2Extended } from '../../../../../models';
import Alert, { AlertType } from '../../../../Alert';

export const VastContent: React.FC<{
  creativeName: string;
  creativeType: CreativeV5Type;
  assets?: Asset2Extended[] | null;
  trialsWithoutAssets?: IngestionTrial[];
  creativeId?: string;
  derivedCreativeReviewStatus?: Asset2ReviewStatus;
  derivedCreativeTranscodingStatus?: Maybe<Asset2TranscodingStatus>;
}> = ({
  creativeName,
  creativeType,
  assets,
  trialsWithoutAssets,
  creativeId,
  derivedCreativeReviewStatus,
  derivedCreativeTranscodingStatus,
}) => {
  // No assets and no ingestion errors present
  if (!assets?.length && !trialsWithoutAssets?.length && creativeType !== CreativeV5Type.Drax) {
    return (
      <Alert type={AlertType.INFORMATION} bodyText={`Assets not available. Click below to begin asset ingestion.`} />
    );
  }

  return (
    <>
      {!!assets?.length && (
        <AssetSlider
          title={creativeName}
          assets={assets}
          creativeId={creativeId}
          derivedCreativeReviewStatus={derivedCreativeReviewStatus}
          derivedCreativeTranscodingStatus={derivedCreativeTranscodingStatus}
        />
      )}
      {!!trialsWithoutAssets?.length && (
        <Alert
          className="vast-content-alert"
          type={assets?.length ? AlertType.WARNING : AlertType.ERROR}
          headerText={`${assets?.length ? 'Additional ' : ''}Ingestion Errors`}
          bodyText={
            <ul>
              {trialsWithoutAssets.map((trial, i) => {
                const { __typename, ...trialData } = trial;
                return <li key={i}>{JSON.stringify(trialData, null, 1)}</li>;
              })}
            </ul>
          }
        />
      )}
    </>
  );
};
